/** Clone API/Fake data that is already JSON-serializable. Not for Date, Map,
 * functions, circular objects or other values outside the JSON data model.
 */
export function cloneJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
